/**
 * Route for `cc-subscribe`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CcSubscribePage } from "../features/cc-subscribe/CcSubscribePage";

export const ccSubscribeRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/cc-subscribe",
	component: CcSubscribePage,
});

export default ccSubscribeRoute;
